import { render } from "./DropdownNavMenu.vue?vue&type=template&id=163db9aa"
import script from "./DropdownNavMenu.vue?vue&type=script&lang=js"
export * from "./DropdownNavMenu.vue?vue&type=script&lang=js"
script.render = render

export default script